import {Checkbox, FormControlLabel} from "@material-ui/core";
import {useState} from "react";
const useCheckBox = ({label}) =>{
    const [checked, setChecked] = useState(false);
    const CheckBox =
         (
            <FormControlLabel
                control={ <Checkbox checked={checked} onChange={()=>{setChecked(!checked)}} name="checkedA" color={"secondary"} />}
                label={<span style={{ fontSize: '14px' }}>{label?label:""}</span>}
            />
        );
    return {
        get: checked,
        CheckBox: CheckBox,
        set: setChecked
    }

}
export default useCheckBox;